import React, { Component } from 'react'

// redux
import { connect } from 'react-redux'
import { Row, Col, Divider, Input, Button, Spin, Avatar, Tooltip } from 'antd'
import { FaReply, FaShare } from 'react-icons/fa'
import QMAction from '../../redux/quickMessage/actions'
import moment from 'moment'

const default_avatar = require('../../resource/image/defaultUser.png')

// props
// onSuccess(selectList): Khi nguoi dung lua chon
// onCancel(): khi nguoi dung khong chon
// initEvent: khoi tao select
class ReplyItem extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isShowingInput: false,
            dataInput: '',
        }
    }
    componentDidMount() {}
   
    onClickReply = () => {
        if (this.state.isShowingInput) {
            console.log('reply_id send', this.props.data.reply_id)
            let body = {
                content: this.state.dataInput,
                reply_id: this.props.data.reply_id,
                messid: this.props.message.messid,
            }
            this.props.sendReplyInReply(body)
            this.setState({ isShowingInput: false })
        } else {
            this.props.getReplyInReply(this.props.data.reply_id)
            this.setState({ isShowingInput: true })
        }
    }
    getCurrentReplyIn1Mess = reply_id => {
        let data = this.props.listReplyInReply.filter(vl => {
            return vl.key === reply_id
        })

        if (data) {
            let lstReply = []
            data.map(vl => {
                lstReply = lstReply.concat(vl.value)
            })

            return lstReply
        }
    }
    getCurrentUserDisplay = reply => {
        if (this.props.receiverInfo.length > 0) {
            if (reply.owner_id === this.props.userInfo.uid) {
                return this.props.userInfo
            } else {
                let user = this.props.receiverInfo.find(vl => {
                    return vl.uid === reply.owner_id
                })
                if (user) {
                    return user
                }
            }
        } else {
            return {}
        }
    }
    getTime = time => {
        const tm = moment().unix() - time
        if (tm < 3600) {
            return (tm / 60) >> 0
        }
        if (tm < 86400) {
            return (tm / 3600) >> 0
        }
        if (tm > 86400) {
            return (tm / 86400) >> 0
        }
    }
    getUnitTime = time => {
        const tm = moment().unix() - time
        if (tm < 3600) {
            return 'minutes'
        }
        if (tm < 86400) {
            return 'hours'
        }
        if (tm > 86400) {
            return 'days'
        }
    }
    render() {
        console.log('this.props.data.reply_id', this.props.listReplyInReply)
        return (
            <div style={{ width: '100%' }}>
                {this.props.listReplyInReply &&
                    this.getCurrentReplyIn1Mess(this.props.data.reply_id) &&
                    this.getCurrentReplyIn1Mess(this.props.data.reply_id).map(
                        reply => (
                            <div style={{ marginBottom: 5, display:'flex', flexDirection:'row' }}>
                                <Avatar
                                    size={48}
                                    src={
                                        this.getCurrentUserDisplay(reply)
                                            .avatar === ''
                                            ? default_avatar
                                            : this.getCurrentUserDisplay(reply)
                                                  .avatar
                                    }
                                    style={{
                                        padding: 5,
                                        objectFit: 'contain',
                                    }}
                                />
                                <div style={{display: 'flex', flexDirection:'column', justifyContent:'center'}}>
                                <text
                                    style={{
                                        color: 'white',
                                        paddingLeft: 10,
                                        fontSize: 13,
                                    }}
                                >
                                    {this.getCurrentUserDisplay(reply).display_name}: {reply.content}
                                </text>
                                <text 
                                 style={{
                                    color: 'white',
                                    paddingLeft: 10,
                                    fontSize: 11,

                                }}>
                                    {moment()
                                    .subtract(
                                        this.getTime(reply.created_time),
                                        this.getUnitTime(reply.created_time)
                                    )
                                    .fromNow()}
                                </text>
                                </div>
                            </div>
                        )
                    )}
                {this.state.isShowingInput && (
                    <Input
                        onChange={vl =>
                            this.setState({ dataInput: vl.target.value })
                        }
                        style={{ width: 500 }}
                        placeholder="Nhập để trả lời"
                    />
                )}
                <Button
                    style={{ marginLeft: 10 }}
                    onClick={() => {
                        this.onClickReply()
                    }}
                >
                    <FaReply style={{ paddingRight: 5 }} /> Trả lời
                </Button>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        listReplyInReply: state.QMreducer.listReplyInReply,
        receiverInfo: state.QMreducer.receiverInfo,
        userInfo: state.auth.userInfo,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getReplyInReply: reply_id => {
            dispatch(QMAction.action.getReplyInReply(reply_id))
        },
        sendReplyInReply: body => {
            dispatch(QMAction.action.sendReplyInReply(body))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ReplyItem)
